<template>
    <div class="col-lg-10 col-md-8 col-12 main">
        <img v-for="(item, index) in list" :key="index" :src="item.img" :alt="item.alt" style="width: 100%; margin-bottom: 0px;" />
    </div>
</template>
<script>
export default {
    name: "home",
    data() {
        return {
            list: [
                { img: require("@/assets/resource/club_forum_event/forum/1.png"), alt: "123" },
                { img: require("@/assets/resource/club_forum_event/forum/2.png"), alt: "123" },
                { img: require("@/assets/resource/club_forum_event/forum/3.png"), alt: "123" },
                { img: require("@/assets/resource/club_forum_event/forum/4.png"), alt: "123" },
                { img: require("@/assets/resource/club_forum_event/forum/5.png"), alt: "123" },
                { img: require("@/assets/resource/club_forum_event/forum/6.png"), alt: "123" },
            ],
        }
    },


};
</script>
<style scoped>
/* 
*{border:1px solid #000;} */

.main {
    height: 100vh;
    padding: 30px 15px;
}

@media (max-width: 768px) {
    .main {
        padding-top: 0px;
        height: calc(100vh - 90px);
    }

}
</style>
